import { Divider as MuiDivider, DividerProps } from '@mui/material';

import { tokens } from '../../theme/generated/tokens';
import { mergeSx } from '../../utils';

type Props = Omit<DividerProps, 'light'> & {
  /** Alias for `sx.borderColor`. Defaults to `border.structural.neutral`. */
  color?: string;
};

export const Divider = ({
  color = tokens.theme.border.structural.neutral,
  sx,
  ...props
}: Props) => {
  return <MuiDivider {...props} sx={mergeSx({ borderColor: color }, sx)} />;
};
